<template>
  <b-modal
    id="modal-viewer"
    ref="modalViewer"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    :title="$t('viewer.modal.title')"
    centered
    modal-class="modalViewer"
    static
    size="sm"
  >
    <div>
      <b-form-input
        id="title"
        v-model="title"
        :placeholder="$t('viewer.modal.title_placeholder')"
        class="mt-1"
      />
      <div class="form-label mt-2">
        <label>{{ $t('viewer.modal.show_title') }}</label>
      </div>
      <div class="d-flex">
        <div class="col-3 switch-btn p-0">
          <input
            id="show_title_toggle"
            v-model="showTitle"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="show_title_toggle"
            class="switch"
          />
        </div>
      </div>
      <b-form-textarea
        id="textarea"
        v-model="text"
        :placeholder="$t('viewer.modal.description_placeholder')"
        rows="4"
        max-rows="4"
        no-resize
        class="mt-3"
      />
      <div
        v-if="hasArea"
        class="form-label mt-3"
      >
        <label>{{ $t('viewer.modal.show_area') }} (<span
          v-if="area"
          v-html="area"
        /><span v-if="!area">{{ $t('viewer.modal.no_scale_defined') }}</span>) </label>
      </div>
      <div
        v-if="hasArea"
        class="d-flex"
      >
        <div class="col-3 switch-btn p-0">
          <input
            id="show_area_toggle"
            v-model="showArea"
            type="checkbox"
            class="offscreen"
            :disabled="!area"
            aria-hidden="true"
          >
          <label
            for="show_area_toggle"
            class="switch"
          />
        </div>
      </div>
      <div class="form-label mt-3">
        <label>{{ $t('viewer.modal.annotation_color') }}</label>
      </div>
      <div class="color-row d-flex">
        <b-button
          :class="{'active-color': selectedColor === 'rgb(0, 0, 0)'}"
          style="background: rgb(0, 0, 0) !important;"
          class="color-btn modal-color-btn ml-1"
          @click="changeColor('rgb(0, 0, 0)')"
        />
        <b-button
          :class="{'active-color': selectedColor === 'rgb(255, 255, 255)'}"
          style="background: rgb(255, 255, 255) !important;"
          class="color-btn modal-color-btn ml-1"
          @click="changeColor('rgb(255, 255, 255)')"
        />
        <b-button
          :class="{'active-color': selectedColor === 'rgb(77, 77, 218)'}"
          style="background: rgb(77, 77, 218) !important;"
          class="color-btn modal-color-btn ml-1"
          @click="changeColor('rgb(77, 77, 218)')"
        />
        <b-button
          :class="{'active-color': selectedColor === 'rgb(83, 255, 106)'}"
          style="background: rgb(83, 255, 106) !important;"
          class="color-btn modal-color-btn ml-1"
          @click="changeColor('rgb(83, 255, 106)')"
        />
        <b-button
          :class="{'active-color': selectedColor === 'rgb(244, 255, 83)'}"
          style="background: rgb(244, 255, 83) !important;"
          class="color-btn modal-color-btn ml-1"
          @click="changeColor('rgb(244, 255, 83)')"
        />
        <b-button
          :class="{'active-color': selectedColor === 'rgb(240, 40, 13)'}"
          style="background: rgb(240, 40, 13) !important;"
          class="color-btn modal-color-btn ml-1"
          @click="changeColor('rgb(240, 40, 13)')"
        />
      </div>
    </div>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="onCancel"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            @click="onOk"
          >
            <span class="fal fa-save mr-2" />
            {{ $t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
    name: 'ModalViewer',
    data() {
        return {
            onOk: () => {},
            onCancel: () => {},
            title: null,
            text: null,
            showArea: false,
            showTitle: false,
            selectedColor: null,
            area: null,
            type: null
        }
    },
    methods: {
        async show(title, text, showArea, showTitle, selectedColor, area, type, onOk, onCancel) {
            this.title = title
            this.text = text
            this.showArea = showArea
            this.showTitle = showTitle
            this.selectedColor = selectedColor
            this.area = area
            this.type = type
            this.onOk = onOk || (() => {})
            this.onCancel = onCancel || (() => {})
            this.$refs.modalViewer.show()
        },
        changeColor(color) {
            this.selectedColor = color
        },
        hide() {
            this.$_cleanComponentData()
            this.$refs.modalViewer.hide()
        },
        hasArea() {
            return this.type === 'Polygon' || this.type === 'Circle' || this.type === 'Square'
        }
    }
}
</script>

<style lang="scss">
    .modalViewer .form-label {
        color: vt-color(white-light, .5);
    }
    .modalViewer input,
    .modalViewer textarea {
        background: vt-color(viewer-main, .4) !important;
        border: none;
        color: vt-color(white-light) !important;
    }
    .modalViewer .color-row .btn {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 10px !important;
        border: none;
    }
    .modalViewer .color-row .btn:hover {
        box-shadow: 0px 0px 3px 3px #9c9c9c;
    }
    .modalViewer .color-row .btn.active-color {
        box-shadow: 0px 0px 3px 3px #9c9c9c !important;
    }
</style>

<style lang="scss" scoped>
    .offscreen {
        position: absolute;
        left: -9999px;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 20px;
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        transition: all 0.3s;
    }

    .switch::after {
        content: '';
        position: absolute;
        width: 18px;
        height: 18px;
        border-radius: 18px;
        background-color: white;
        top: 1px;
        left: 1px;
        transition: all 0.3s;
    }

    input[type='checkbox']:checked + .switch::after {
        transform: translateX(20px);
    }

    input[type='checkbox']:checked + .switch {
        background-color: vt-color(primary);
    }

    .modal-color-btn {
        height: 20px;
        width: 20px;
    }
</style>
